/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { decodeEntities } from '@wordpress/html-entities';
import { formatParamArray, removeParamFromArray } from '../utils/helpers.js';

/**
 * Get initial value
 * @param {Object} currentParams - URLSearchParams object
 * @param {Object} category - Category object
 * @return {Boolean}
 */
const getInitialArrayValue = (type, currentParams, id) => {
	const values = currentParams.get(type)?.split(',') || [];
	return values.includes(id);
};

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function FilterCategoryCheckbox({
	id,
	type,
	label,
	slug,
	searchParams,
	setSearchParams,
}) {
	const [checked, setChecked] = useState(
		getInitialArrayValue(type, searchParams, id)
	);

	/**
	 * Handle change
	 * @param {Object} e
	 * @return {void}
	 */
	const handleChange = (e) => {
		const { target } = e;
		const { value } = target;

		setSearchParams((params) => {
			const categories = params.get(type)?.split(',') || [];

			// Handle checked
			if (target.checked) {
				categories.push(value);

				params.set(type, formatParamArray(categories));
				return params;
			}

			// Handle unchecked
			const newCategories = removeParamFromArray(categories, value);

			newCategories.length === 0
				? params.delete(type)
				: params.set(type, formatParamArray(newCategories));

			return params;
		});

		setChecked(target.checked);
	};

	return (
		<label
			htmlFor={slug}
			className="course__filter-item"
			data-active={checked}
		>
			<input
				id={slug}
				type="checkbox"
				className="course__filter-item__checkbox"
				name={slug}
				value={id}
				defaultChecked={checked}
				onChange={handleChange}
			/>
			{decodeEntities(label)}
		</label>
	);
}

export default FilterCategoryCheckbox;
